import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";
import { url_284, url_285 } from "../../custom_utilities/api_services";

const MISTAKE_BOOK_PAPER_TYPE = 22;

const submitExamPracticeApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_submit_practice";

const saveAnswerPracticeApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_singlesave_practice";

/** Drop undefined / null / "" / "undefined" / "null" from query params. */
const buildCleanParams = (params = {}) => {
  const query = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const text = String(value).trim();
    if (!text || text.toLowerCase() === "undefined" || text.toLowerCase() === "null") {
      return;
    }
    query[key] = value;
  });
  return query;
};

/**
 * Quiet last-answer save before submit — does not touch Redux `loading`,
 * so the exam UI does not flicker to a full-screen spinner.
 */
export const saveMistakeBookAnswer = async (payload = {}) => {
  const {
    practiceMode,
    gamificationOn,
    skipAdvance: _skip,
    awaitSave: _await,
    triggerStreak: _streak,
    ...rest
  } = payload;

  const apiUrl =
    practiceMode === "practice" ? saveAnswerPracticeApi : url_284;

  const body = buildCleanParams({
    ...rest,
    gamification_status:
      practiceMode === "practice" && gamificationOn ? 1 : undefined,
  });

  const response = await axioInstance.post(apiUrl, body);
  return response?.data;
};

/**
 * Submit a Mistake Book practice set with clean query params only.
 * Shared examApi always appends paper_id=undefined / test_id=undefined which
 * can prevent the backend from marking the set completed.
 */
export const submitMistakeBookPracticeSet = async ({
  paperType = MISTAKE_BOOK_PAPER_TYPE,
  setId,
  paperId,
  testId,
  time,
  practiceMode,
  gamificationOn,
} = {}) => {
  const apiUrl =
    practiceMode === "practice" ? submitExamPracticeApi : url_285;

  const query = buildCleanParams({
    paper_type: paperType ?? MISTAKE_BOOK_PAPER_TYPE,
    set_id: setId,
    paper_id: paperId,
    test_id: testId,
    time: time ?? 0,
    gamification_status:
      practiceMode === "practice" && gamificationOn ? 1 : undefined,
  });

  const search = new URLSearchParams(
    Object.entries(query).map(([key, value]) => [key, String(value)])
  ).toString();

  const response = await axioInstance.post(`${apiUrl}?${search}`);
  const body = response?.data;

  if (body && !(body.status === 200 || body.status === "200")) {
    const error = new Error(
      body?.message || "Unable to submit this practice set right now."
    );
    error.response = { data: body };
    throw error;
  }

  return body;
};
